import { useQuery } from '@tanstack/react-query'
import { axiosInstance } from '@/lib/axios'
import { MINUTE_IN_MS } from '@/modules/shared/constants/time'
import { Driver } from './types'

type Props = {
  companyId: string
  startTime: string
  endTime: string
  page?: number
  pageSize?: number
  status?: 'active' | 'inactive' | 'all'
  enabled?: boolean
}

export type DriversFormResponse = {
  drivers: Driver[]
  totalCount?: number
}

export function useQueryDriversForm({
  companyId,
  startTime,
  endTime,
  page = 1,
  pageSize = 10000,
  status = 'active',
  enabled = true,
}: Props) {
  return useQuery<DriversFormResponse>({
    queryKey: [
      'drivers-form',
      companyId,
      startTime,
      endTime,
      page,
      pageSize,
      status,
    ],
    queryFn: async () => {
      const params = new URLSearchParams()
      params.append('startTime', startTime)
      params.append('endTime', endTime)
      params.append('page', String(page))
      params.append('pageSize', String(pageSize))
      params.append('status', status)

      const { data } = await axiosInstance.get<DriversFormResponse | Driver[]>(
        `/api/${companyId}/drivers/form?${params.toString()}`,
      )

      if (Array.isArray(data)) {
        return { drivers: data }
      }
      return data
    },
    enabled: enabled && !!companyId && !!startTime && !!endTime,
    staleTime: MINUTE_IN_MS * 5,
  })
}
